module.exports = __webpack_public_path__ + "TextaNarrow-Bold-webfont.2690a96ca0a4632dd40e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Bold-webfont.ttf
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Bold-webfont.ttf
// module chunks = styles